import { IBaseModuleComponent } from '../component/IBaseComponent';
import { AppInjector } from "@core/injector/injector.module";
import { AppConfigService } from '@configuration/app.config.service';
import { SessionService } from '@core/framework/session.service';
import { UiService } from '@core/framework/ui.service';
import { ServiceBagService } from '../component/ServiceBag';
import { Observable, observable, pipe, tap } from 'rxjs';
import { BaseResponse } from '../entities/BaseEntities';

export class BaseService implements IBaseModuleComponent {
    ModuleName: string = AppInjector.get(AppConfigService).getModuleNameByInstance(this);

    get UserInfo(): any {
        const session = AppInjector.get(SessionService);
        return this.ModuleName ? session.UserInfoDict[this.ModuleName] : session.UserInfos[0];
    }

    public get UI(): UiService {
        const serviceBagService = AppInjector.get(ServiceBagService);
        return serviceBagService.UI;
    }

    public RC(value, ...args: string[] | number[]): string {
        const serviceBagService = AppInjector.get(ServiceBagService);
        return serviceBagService.ResourcesService.RC(value, this.ModuleName, ...args);
    }

    protected handleResponse<T extends BaseResponse>() {
        return (observable: Observable<T>) => {
            return observable.pipe(tap((response) => {
                if (!response.IsSuccess) {
                    this.UI.StopMessage(response.ResponseMessage);
                }
            }));
        };
    }
}